import { Box, Text, Flex, Button, ActionIcon } from '@mantine/core';
import { IconX, IconUser } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { CalendarEvent } from 'src/meetings/models';
import { formatEventBannerDate } from 'src/meetings/utils/date-utils';
import { GuestSummary } from './GuestSummary';
import { PreMeetingInformation } from './PreMeetingInformation';

type Props = {
  event: CalendarEvent;
  onClose: () => void;
};

export const EventOverview = ({ event, onClose }: Props) => {
  const bannerText = formatEventBannerDate(event.scheduledStartAt, event.scheduledEndAt);

  return (
    <Box>
      <Flex justify="space-between" align="flex-start" mb="lg">
        <Box
          bg="brand.1"
          py="xxxs"
          px="xxs"
          style={{
            borderRadius: '4px',
            display: 'inline-block',
          }}
        >
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
            Upcoming: {bannerText}
          </Text>
        </Box>

        <ActionIcon variant="subtle" onClick={onClose} c="gray.10">
          <IconX size={16} />
        </ActionIcon>
      </Flex>

      <Text size="displaySm" fw={FONT_WEIGHTS.semibold} c="gray.10" mb="lg">
        {event.title}
      </Text>

      <Flex justify="space-between" align="center" mb="lg">
        <Flex align="center" gap="xxxs">
          <IconUser size={16} />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
            <GuestSummary event={event} />
          </Text>
        </Flex>

        {event.meetingUrl && (
          <Button variant="primary" onClick={() => window.open(event.meetingUrl!, '_blank')}>
            Join meeting
          </Button>
        )}

        {!event.meetingUrl && (
          <Button variant="primary" disabled>
            Join meeting
          </Button>
        )}
      </Flex>

      <PreMeetingInformation event={event} />
    </Box>
  );
};
